<app-header></app-header>
<div class="main-container">
  <app-side-menu></app-side-menu>
  <div class="content">
    <router-outlet />
  </div>
</div>
<app-footer></app-footer>